export default {
  nav_home: 'Startseite',
  nav_guides: 'Anleitungen',
  nav_categories: 'Kategorien',
  nav_shopping_guide: 'Einkaufsführer',
  nav_safety: 'Sicherheit',
  nav_faq: 'FAQ',
  nav_about: 'Über uns',
  hero_eyebrow: 'CSSBuy Spreadsheet • Anleitungen • Produkte • Tipps',
  hero_h1: 'CSSBuy Spreadsheet — Finden Sie Produkte, Verkäufer & Anleitungen an einem Ort',
  hero_desc: 'Finden und organisieren Sie nützliche CSSBuy-Ressourcen mit Leichtigkeit. Erkunden Sie CSSBuy-Spreadsheets, Produkte, Verkäufer, QC-Anleitungen, Versandinformationen, Lager, Coupons und praktische Tipps, um besser zu recherchieren und fundiertere Entscheidungen zu treffen.',
  hero_cta_primary: 'CSSBuy Spreadsheet erkunden',
  hero_cta_secondary: 'CSSBuy-Anleitungen ansehen',
  hero_search_placeholder: 'Suchen Sie nach Produkt, Kategorie oder CSSBuy Spreadsheet...',
  trust_recursos: 'Organisierte Ressourcen',
  trust_atualizado: 'Aktualisierter Inhalt',
  trust_guides: 'Praktische Anleitungen',
  trust_seguranca: 'Sicherheitsfokus',
  categories_h2: 'Produktkategorien',
  categories_desc: 'Stöbern Sie in den beliebtesten Kategorien und finden Sie, was Sie suchen.',
  cta_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  cta_buy_it_now: 'Jetzt kaufen',
  cta_visit_main: 'Hauptwebsite besuchen',
  articles_h2: 'CSSBuy-Anleitungen & Artikel',
  articles_desc: 'Lesen Sie unsere vollständigen Anleitungen, um fundiertere Entscheidungen zu treffen.',
  article_read_guide: 'Anleitung lesen',
  footer_resources: 'Ressourcen',
  footer_categories: 'Kategorien',
  footer_legal: 'Rechtliches',
  footer_privacy: 'Datenschutz',
  footer_terms: 'Nutzungsbedingungen',
  footer_disclaimer: 'Haftungsausschluss',
  footer_disclaimer_text: 'Dies ist eine unabhängige Informations- und Ressourcen-Website. Wir sind nicht offiziell mit CSSBuy verbunden, gesponsert oder unterstützt, es sei denn, dies wird ausdrücklich angegeben.',
  footer_copyright: '© 2026 cssbuybr.living — Alle Rechte vorbehalten.',
  review_h2: 'CSSBuy Review: Was Sie vor dem Kauf wissen müssen',
  review_desc: 'Verstehen Sie, wie Produkte, Verkäufer, Lager, Qualitätskontrolle und Versand funktionieren, bevor Sie eine Entscheidung treffen. Unser CSSBuy Review Guide bündelt praktische Informationen, um Ihnen zu helfen, den Service fundierter zu bewerten.',
  review_cta: 'CSSBuy Review lesen',
  shipping_h2: 'CSSBuy Shipping Cost: Versandkosten verstehen',
  shipping_desc: 'Die Versandkosten können je nach Gewicht, Volumen, Bestimmungsort und gewählter Methode variieren. Sehen Sie sich unsere Anleitung an, um die Hauptfaktoren zu verstehen, die den Preis beeinflussen, bevor Sie Ihren Kauf abschließen.',
  shipping_cta: 'CSSBuy Shipping Cost ansehen',
  coupon_h2: 'CSSBuy Coupon & Discount Code',
  coupon_desc: 'Sehen Sie sich unseren CSSBuy Coupon und CSSBuy Discount Code Guide an, um zu verstehen, wo Sie nach Werbeaktionen suchen, wie Sie Bedingungen überprüfen und wie Sie veraltete oder verdächtige Codes vermeiden.',
  coupon_cta: 'Coupons & Rabatte ansehen',
  how_it_works_h2: 'Wie man ein CSSBuy Spreadsheet verwendet',
  how_step_1: 'Wählen Sie eine Kategorie',
  how_step_2: 'Finden Sie ein Produkt oder eine Ressource',
  how_step_3: 'Überprüfen Sie Verkäufer und Informationen',
  how_step_4: 'Überprüfen Sie QC, wenn verfügbar',
  how_step_5: 'Analysieren Sie Versand und Kosten',
  how_step_6: 'Treffen Sie Ihre Entscheidung',
  how_cta: 'Mit CSSBuy Spreadsheet beginnen',
  comparison_h2: 'CSSBuy Spreadsheet vs. Manuelle Suche',
  comparison_criterio: 'Kriterium',
  comparison_spreadsheet: 'CSSBuy Spreadsheet',
  comparison_manual: 'Manuelle Suche',
  comparison_organizacao: 'Organisation',
  comparison_alta: 'Hoch',
  comparison_variavel: 'Variabel',
  comparison_descoberta: 'Entdeckung',
  comparison_simples: 'Einfacher',
  comparison_demorada: 'Zeitaufwändiger',
  comparison_categorias: 'Kategorien',
  comparison_estruturadas: 'Strukturiert',
  comparison_dispersas: 'Zerstreut',
  comparison_pesquisa: 'Recherche',
  comparison_centralizada: 'Zentralisiert',
  comparison_diversas: 'Mehrere Quellen',
  comparison_guias: 'Anleitungen',
  comparison_integrados: 'Integriert',
  comparison_separados: 'Separat',
  final_cta_h2: 'Finden Sie Ihr nächstes CSSBuy Spreadsheet',
  final_cta_desc: 'Erkunden Sie Kategorien, Anleitungen, Vergleiche, Versandinformationen, QC und Ressourcen, um Ihre Recherche zu vereinfachen.',
  final_cta_primary: 'CSSBuy Spreadsheet erkunden',
  final_cta_secondary: 'Hauptwebsite besuchen',
  breadcrumb_home: 'Startseite',
  article_updated: 'Aktualisiert',
  article_reading_time: 'Min. Lesezeit',
  related_articles: 'Verwandte Artikel',
  toc_title: 'Inhalt',
  safety_note: 'Sicherheitshinweis',
  safety_note_text: 'Beim internationalen Kauf sollte Sicherheit vor Geschwindigkeit kommen. Lernen Sie, wie Sie Links, Produkte, Verkäufer, Zahlungen, QC und Versandinformationen überprüfen, bevor Sie eine Entscheidung treffen.',
};